exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3tk5B{width:100%}", ""]);

// exports
exports.locals = {
	"container": "_3tk5B"
};